import { ApprovalState, WorkGroupsType } from '@lichtblick/types';

export const calcProgress = (group: WorkGroupsType) => {
  const allItems = group.items.flatMap((item) => item.items);
  const doneItems = allItems.filter((item) => item.status === ApprovalState.ServerApproved);

  return Math.round((doneItems.length / allItems.length) * 100);
};
